import { render, staticRenderFns } from "./SettingsOrganizations.vue?vue&type=template&id=2ce2fa7e"
import script from "./SettingsOrganizations.vue?vue&type=script&lang=js"
export * from "./SettingsOrganizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports